<div class="partner-home">
  <div class="partner-home__content">
    <div class="partner-home__header">
      <div>
        <h1 class="page-title">Partners</h1>
        <p class="page-subtitle">Manage partners and their details.</p>
      </div>
    </div>

    <app-table
      [data]="partnerState.data()"
      [columns]="partnerColumns"
      [config]="partnerConfig"
      [pagination]="partnerPagination"
      (sortChange)="onSortChange($event)"
      (pageChange)="onPageChange($event)"
      (pageSizeChange)="onPageSizeChange($event)"
      (actionClick)="onActionClick($event)"
      (searchChange)="onSearchChange($event)"
      (filterChange)="onFilterChange($event)"
      (dateRangeChange)="onDateRangeChange($event)"></app-table>
  </div>

  @if (isPublicLinkModalOpen) {
  <div
    class="partner-home__modal-backdrop"
    role="button"
    tabindex="0"
    (click)="closePublicRequestLink()"
    (keydown.enter)="closePublicRequestLink()"
    (keydown.space)="closePublicRequestLink()">
    <section
      class="partner-home__modal"
      tabindex="-1"
      (click)="$event.stopPropagation()"
      (keydown.enter)="$event.stopPropagation()"
      (keydown.space)="$event.stopPropagation()">
      <header class="partner-home__modal-header">
        <div>
          <h2 class="partner-home__modal-title">Public Request Link</h2>
          <p class="partner-home__modal-copy">
            {{ publicLinkPartner?.name }} can receive draft requests from a generated URL valid for 12 hours.
          </p>
        </div>
        <button
          type="button"
          class="partner-home__modal-close"
          (click)="closePublicRequestLink()"
          aria-label="Close public link modal">
          ×
        </button>
      </header>

      @if (isPublicLinkLoading) {
      <div class="partner-home__modal-loading">Loading link settings...</div>
      } @else {
      <div class="partner-home__modal-body">
        <section class="partner-home__modal-section">
          <div class="partner-home__section-heading">
            <span>Default warehouse</span>
            <p>Public requests created from this URL use this warehouse. Regenerating creates a fresh 12-hour URL.</p>
          </div>
          <form [formGroup]="publicLinkForm" class="partner-home__link-form">
            <app-autocomplete
              [prefetchOnInit]="true"
              [options]="publicLinkWarehouseOptions"
              [selectedValue]="publicLinkForm.value.warehouseId || ''"
              [minLength]="1"
              [debounceMs]="300"
              placeholder="Search warehouse..."
              (searchChange)="searchPublicLinkWarehouses($event)"
              (selectionChange)="onPublicLinkWarehouseChange($event)"></app-autocomplete>
          </form>
        </section>

        <section class="partner-home__modal-section partner-home__modal-section--status">
          <div
            class="partner-home__link-status"
            [class.partner-home__link-status--enabled]="publicLinkMetadata?.enabled"
            [class.partner-home__link-status--expired]="publicLinkMetadata?.expired">
            <span class="partner-home__status-dot"></span>
            <div>
              <strong>{{ getPublicLinkStatusLabel() }}</strong>
              <p>{{ getPublicLinkStatusDescription() }}</p>
              <small>{{ getPublicLinkExpiryLabel() }}</small>
            </div>
          </div>
        </section>

        @if (generatedPublicUrl) {
        <div class="partner-home__generated-link">
          <div class="partner-home__section-heading">
            <span>Generated URL</span>
            <p>This token is shown only after regeneration and expires after 12 hours.</p>
          </div>
          <div class="partner-home__generated-link-row">
            <input class="partner-home__generated-link-input" type="text" readonly [value]="generatedPublicUrl" />
            <div class="partner-home__generated-link-actions">
              <button
                type="button"
                class="partner-home__icon-button"
                (click)="copyGeneratedPublicUrl()"
                aria-label="Copy generated public URL"
                title="Copy URL">
                <ng-glyph name="content_copy" size="18"></ng-glyph>
              </button>
              <a
                [href]="generatedPublicUrl"
                target="_blank"
                rel="noopener noreferrer"
                class="partner-home__icon-button"
                aria-label="Open generated public URL in a new tab"
                title="Open in new tab">
                <ng-glyph name="open_in_new" size="18"></ng-glyph>
              </a>
            </div>
          </div>
        </div>
        }
      </div>

      <footer class="partner-home__modal-actions">
        <app-button type="button" variant="secondary" (click)="closePublicRequestLink()">Close</app-button>
        <app-button
          type="button"
          variant="danger"
          [disabled]="isPublicLinkSaving || !publicLinkMetadata?.enabled"
          (click)="disablePublicRequestLink()">
          Disable
        </app-button>
        <app-button type="button" [disabled]="isPublicLinkSaving || publicLinkForm.invalid" (click)="regeneratePublicRequestLink()">
          {{ isPublicLinkSaving ? "Generating..." : "Regenerate Link" }}
        </app-button>
      </footer>
      }
    </section>
  </div>
  }
</div>
